module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_neumann_sm-8f0753bf8e11e48033237c80924d8da2.png";